import {withRouter as router} from "react-router-dom"
import React from "react";
import config from '../../config/upload'
import {Button, message, Input, Upload} from 'antd'
import {UploadOutlined} from '@ant-design/icons';
import Tips from '../../components/tips/tips'
import qs from '../../utils/qs'
import './css/register.sass'
import 'moment/locale/zh-cn';
import api from "../../utils/api";
import {tokenStatus, USE_ABLE} from "../../store/token";
import {state} from '../../store';

function getBase64 (img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

class Register extends React.Component {
    constructor (args) {
        super(args)
        let status = tokenStatus(state);
        if (status === USE_ABLE) {
            this.props.history.push({pathname: '/'});
        } else {
            let token = qs.hrefParam('token');
            if (!token) {
                this.props.history.push({pathname: '/login'});
            }
        }
        this.state = {
            customer_id: null,
            loading: false,
            imageUrl: '',
            noimageUrl: false,
            fontImg: '',
            nofontImg: false,
            backImg: '',
            nobackImg: false,
            supplyName: '',
            nosupplyName: false,
            supplyMobile: null,
            nosupplyMobile: false,
            businessImg: '',
            nobusinessImg: false,
            smsTxt: '获取验证码',
            smsSeconds: 60,
            smsTimer: null,
            smscode: null,
            nosmscode: false
        }
    }

    componentWillUnmount () {
    }

    async componentDidMount () {


    }

    handleChange = info => {
        if (info.file.status === 'uploading') {
            this.setState({loading: true});
            return;
        }
        if (info.file.status === 'done') {
            message.success('图片上传成功！')
            // Get this url from response in real world.
            getBase64(info.file.originFileObj, imageUrl =>
                this.setState({
                    imageUrl: info.file['response']['data']['url'],
                    loading: false,
                    noimageUrl: false
                }),
            );
        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
        }
    };

    handlePreview = (e) => {
        //console.log(e)
    }


    beforeUpload = (e) => {
        message.loading('图片上传中')
    }

    getSms = async () => {//
        let {smsTimer, smsSeconds, supplyMobile} = this.state;

        if (smsTimer) {
            return message.error('不能重复请求')
        }


        let arg = /^1[0-9]{10}$/;

        if (!arg.test(supplyMobile)) {
            return message.error('手机号格式不正确！')
        }

        const hide = message.loading('请求中')

        let res = {}

        if (res.code == 200) {
            message.success('验证码发送成功！')

            smsTimer = setInterval(() => {
                if (smsSeconds > 1) {
                    smsSeconds--;
                    this.setState({
                        smsTxt: smsSeconds + 's'
                    })
                } else {
                    smsSeconds = 60;
                    this.setState({
                        smsTxt: '获取验证码',
                        smsTimer: null
                    })
                    clearInterval(smsTimer)
                }
            }, 1000)

            this.setState({
                smsTimer,
                smsSeconds
            })
        }

        hide()
    }

    clearAll = () => {//重置
        this.setState({
            supplyName: '',
            nosupplyName: false,
            supplyMobile: '',
            nosupplyMobile: false,
            smscode: '',
            nosmscode: false,
            imageUrl: '',
            noimageUrl: false,
            businessImg: '',
            fontImg: '',
            nofontImg: false,
            backImg: '',
            nobackImg: false
        })

    }

    submit = async () => {//提交
        const {
            customer_id,
            supplyName,
            supplyMobile,
            imageUrl,
            businessImg,
            fontImg,
            nofontImg,
            backImg,
            nobackImg,
            smscode,
            nosmscode
        } = this.state
        let check
        check = qs.isNull(supplyName, '请输入供应商名称', () => {
            this.setState({nosupplyName: true})
        })
        if (!check) return
        check = qs.isNull(supplyMobile, '请输入手机号', () => {
            this.setState({nosupplyMobile: true})
        })
        if (!check) return
        const hide = message.loading('正在提交，请稍后')

        let param = {
            customer_id: customer_id,
            name: supplyName,
            mobile: supplyMobile,
            captcha: smscode,
            avatar: imageUrl,
            business_photos: businessImg,
            id_card_photos: [fontImg, backImg],
            desc: ''
        }

        let res = await api('add-merchant', {...param})
        if (res.status) {
            message.success(res.message)
            await window.localStorage.setItem('customer_id', customer_id);
            await window.localStorage.setItem('userInfo', JSON.stringify(res['data']));
            await window.localStorage.setItem('token_m', res['data']['token']);
            await window.localStorage.setItem('token_m_old', res['data']['token']);

            setTimeout(() => {
                this.props.history.push({
                    pathname: '/admin'
                })
                message.success('注册成功！')
            }, 1000);
        } else {
            message.error(res.message)
        }

        hide()
    }


    render () {

        const {
            fontImg,
            backImg,
            supplyName,
            nosupplyName,
            supplyMobile,
            nosupplyMobile,
            businessImg,
            nobusinessImg,
            nofontImg,
            nobackImg
        } = this.state;

        const props = {
            name: 'file',
            action: `${config.apiUrl}/admin/upload/upload-image`,
            accept: '.png,.jpg,.jpeg',
            headers: {
                authorization: 'authorization-text',
            },
            beforeUpload: () => {
                message.loading('图片上传中')
            },
            onChange: (info) => {
                if (info.file.status !== 'uploading') {
                }
                if (info.file.status === 'done') {
                    message.success('图片上传成功！')
                    getBase64(info.file.originFileObj, businessImg =>
                        this.setState({
                            businessImg: info.file['response']['data']['url'],
                            nobusinessImg: false
                        })
                    );
                } else if (info.file.status === 'error') {
                    message.error(`${info.file.name} file upload failed.`);
                }
            },
        };

        const fontprops = {
            name: 'file',
            action: `${config.apiUrl}/admin/upload/upload-image`,
            accept: '.png,.jpg,.jpeg,.gif',
            headers: {
                authorization: 'authorization-text',
            },
            showUploadList: false,
            beforeUpload: () => {
                message.loading('图片上传中')
            },
            onChange: (info) => {
                if (info.file.status === 'done') {
                    message.success('图片上传成功！')
                    getBase64(info.file.originFileObj, fontImg => {
                            this.setState({
                                fontImg: info.file['response']['data']['url'],
                                nofontImg: false
                            })
                        }
                    );
                } else if (info.file.status === 'error') {
                    message.error(`${info.file.name} file upload failed.`);
                }
            },
        };


        const backprops = {
            name: 'file',
            action: `${config.apiUrl}/admin/upload/upload-image`,
            accept: '.png,.jpg,.jpeg,.gif',
            headers: {
                authorization: 'authorization-text',
            },
            showUploadList: false,
            beforeUpload: () => {
                message.loading('图片上传中')
            },
            onChange: (info) => {
                if (info.file.status === 'done') {
                    message.success('图片上传成功！')
                    getBase64(info.file.originFileObj, backImg => {
                            this.setState({
                                backImg: info.file['response']['data']['url'],
                                nobackImg: false
                            })
                        }
                    );
                } else if (info.file.status === 'error') {
                    message.error(`${info.file.name} file upload failed.`);
                }
            },
        };

        return (
            <div className='login'>
                <div className='register'>
                    <div className='title'>
                        您还不是商户，请注册商户
                    </div>
                    <div className='line'>
                        <label>*商户名称：</label>
                        <Input value={supplyName} onChange={e => {
                            this.setState({supplyName: e.target.value, nosupplyName: false})
                        }} placeholder='请输入供应商名称'></Input>

                        {nosupplyName ? (
                            <Tips ctx={{ctx: '请输入商户名称：', type: 'error'}}></Tips>
                        ) : null}

                    </div>
                    <div className='line'>
                        <label>*手机号：</label>
                        <Input value={supplyMobile} onChange={e => {
                            this.setState({supplyMobile: e.target.value, nosupplyMobile: false})
                        }} placeholder='请输入手机号'></Input>
                        {/* <button style={{ width: '90px', marginLeft: '10px', height: '30px', cursor: 'pointer' }} onClick={() => { this.getSms() }}>{smsTxt}</button> */}
                        {nosupplyMobile ? (
                            <Tips ctx={{ctx: '请输入手机号', type: 'error'}}></Tips>
                        ) : null}

                    </div>

                    <div className='line flex' style={{alignItems: 'flex-start'}}>
                        <label>营业执照片：</label>

                        <div className='identity flex'>
                            <div className='identityPhoto font'>
                                {
                                    !businessImg ? (<p>营业执照</p>) : null
                                }
                                <div className='uploads'>
                                    <Upload {...props}>
                                        <Button icon={<UploadOutlined/>}>点击上传</Button>
                                    </Upload>
                                </div>
                                {businessImg ? (
                                    <img src={businessImg} alt=''/>
                                ) : null}
                            </div>
                        </div>
                        {nobusinessImg ? (
                            <Tips ctx={{ctx: '请上传营业执照', type: 'error'}}></Tips>
                        ) : null}

                    </div>
                    <div className='line flex' style={{alignItems: 'flex-start'}}>
                        <label>身份证正反照：</label>

                        <div className='identity flex'>
                            <div className='identityPhoto font'>
                                {
                                    !fontImg ? (<p>身份证正面照</p>) : null
                                }
                                <div className='uploads'>
                                    <Upload {...fontprops}>
                                        <Button icon={<UploadOutlined/>}>点击上传</Button>
                                    </Upload>
                                </div>
                                {fontImg ? (
                                    <img src={fontImg} alt=''/>
                                ) : null}


                            </div>
                            <div className='identityPhoto back'>
                                {!backImg ? (<p>身份证反面照</p>) : null}

                                <div className='uploads'>
                                    <Upload {...backprops}>
                                        <Button icon={<UploadOutlined/>}>点击上传</Button>
                                    </Upload>
                                </div>
                                {backImg ? (<img src={backImg} alt=''/>) : null}

                            </div>
                        </div>
                        {
                            nofontImg ? (<Tips ctx={{ctx: '请上传身份证正面照', type: 'error'}}></Tips>) : null
                        }
                        {
                            nobackImg ? (<Tips ctx={{ctx: '请上传身份证反面照', type: 'error'}}></Tips>) : null
                        }

                    </div>

                    <div className='contrl flex'>
                        <div onClick={() => {
                            this.clearAll()
                        }} className='btn'>重置
                        </div>
                        <div onClick={() => {
                            this.submit()
                        }} className='btn com themeBtn'>确定
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default router(Register);